import React, {useEffect} from 'react';
import {TASK_ACTIONS} from 'utils/constants';
import {connect} from 'react-redux';
import {actionFinished} from '../mytasks/action/taskAction.action';
import {getOverviewTasks, getActionParameters} from '../store/application.reducers';
import {showNotification} from '../notifications/notification.action';
import * as logger from 'utils/logger.function';
import {useModalContext} from "components/modals/ModalContext";


/**
 * asynchronous part of the task action - showing the dialog, which will execute the action
 * synchronous part of action is inside redux action
 */
export const AsyncTaskActionExecutor = (props) => {
    const modalContext = useModalContext();
    const {toggleModal} = modalContext || {};
    const actionParameters = props.actionParameters;

    /**
     * opening the modal is a state update on the host, so it cannot happen while rendering.
     * actionParameters is the redux action object, a stable reference until another action is
     * dispatched - so this runs once per requested action rather than on every re-render.
     */
    useEffect(() => {
        // nothing to show
        if (!actionParameters.type) {
            return;
        }

        const taskList = props.tasks && props.tasks.rows ? props.tasks.rows.map((task) => task) : [];

        const tasksForAction = taskList
            .filter((task) => { // find those matching props.taskIds
                return actionParameters.taskIds.some((taskKeyWanted) => {
                    return taskKeyWanted === task.key;
                });
            });

        /**
         * sometimes, when user has dialog opened and navigates away for some time or changes context
         * the keys for task/history details expire, which then results in empty tasks for the popup
         * so detect this situation and rather hide the popup than check for invalid props inside each popup
         */
        if (tasksForAction.length === 0) {
            logger.error("AsyncTaskActionExecutor", "no task to be shown for these keys: " + actionParameters.taskIds);
            props.actionFinished();
            return;
        }

        const handleCloseCallback=()=>{
            props.actionFinished();
            props.reloadTasks();
        }

        const popupProps = {
            closeCallback: handleCloseCallback,
            tasks: tasksForAction,
            showNotification: props.showNotification,
            taskDetails: props.taskDetails,
            skipComments: true
        };

        if (actionParameters.type === TASK_ACTIONS.REASSIGN) {
            toggleModal?.(TASK_ACTIONS.REASSIGN, {...popupProps});
        } else {
            console.error('unmapped action type: ' + actionParameters.type);
        }
    }, [actionParameters]); // eslint-disable-line react-hooks/exhaustive-deps -- once per action, not per render

    return null;
}


const mapStateToProps = function (store) {
    return {
        tasks: getOverviewTasks(store),
        actionParameters: getActionParameters(store),
    };
};

const connected = connect(mapStateToProps, {
    actionFinished,
    showNotification
})(AsyncTaskActionExecutor);


export default connected;